import $ from "jquery";
import * as React from 'react';
import ModalDialog from './ModalDialog';
import { ModalCloseButton } from "./ModalCloseButton";
import { OKButton } from "./OkButton";

class ModalDialogDelete extends React.Component {
    constructor(props) {
        super(props);
        this.state = { id: '', onClickDelete: null };
    }

    handleDelete = () => {
        this.props.onClickDelete();
        $("#closeModal" + this.props.id).click();
    }

    render() {
        return (
            <ModalDialog id={this.props.id}
                bodyMessage={this.props.bodyMessage ? this.props.bodyMessage : 'Are you sure you wish to delete this record?'}
                className={this.props.className}
                titleClassName='text-success'
                footerChild={(
                    <div>
                        <OKButton onClick={this.handleDelete} className='mr-1' />
                        <ModalCloseButton value='Cancel' paddingLeft='18' paddingRight='18' />
                    </div>
                )}>
            </ModalDialog>
        );
    }
}

export default ModalDialogDelete;


// WEBPACK FOOTER //
// ./src/components/Controls/ModalDialogDelete.js